// extracted by mini-css-extract-plugin
module.exports = {"namesTab":"names_namesTab__sQrzR","form":"names_form__q6W6I"};